import { ReferenceData } from '@motivforce/mx-library-angular';

import { Program } from './core/program';
import { UserActivityStatus } from './user/user-activity-status';
import { UserActivityStatusCodes } from './user/user-activity-status-codes';

export interface User {
  id?: number;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  password: string;
  agencyName: string;
  agencyAddress: string;
  agencySuburbCity: string;
  agencyCountryId: number;
  agencyState: string;
  agencyPostcode: string;
  memberId: string;
  agencyGroupId: number;
  countryId: number;
  sendEmail: boolean;
  acceptedTermsConditions: boolean;
  acceptedTermsConditionsDate?: Date;
  companies?: any[];
  program?: Program;
  userRole?: ReferenceData;
  statusId?: number;
  activityStatus?: UserActivityStatus;
}

export function reAcceptTermsAndCondtions(user: User): boolean {
  if (
    user != null &&
    user.activityStatus != null &&
    user.acceptedTermsConditionsDate != null &&
    user.activityStatus.statusAssignedAt != null
  ) {
    const acceptedDate = new Date(user.acceptedTermsConditionsDate);
    const statusAssignedAt = new Date(user.activityStatus.statusAssignedAt);
    if (
      (user.activityStatus.code === UserActivityStatusCodes.Inactive ||
        user.activityStatus.code === UserActivityStatusCodes.Dormant) &&
      acceptedDate.getTime() < statusAssignedAt.getTime()
    ) {
      return true;
    }
  }

  return false;
}
